Card = require 'models/card'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'

module.exports = class CardList extends CollectionWithHelpers
  model: Card
  initialize: (models, options) ->
    @listenTo @, 'change:pos', @sort
    @list = options.list
    return

  url: '/1/cards'

  comparator: (card) -> card.get('pos') || 0



// WEBPACK FOOTER //
// ./app/scripts/models/collections/card-list.coffee